

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TPlatformAgreementDetails, TPlatformUseGetData, TUseAgreementData } from "../types/customers";
import { FinancePartnerInfo } from "./financePartnerSlice";


type TinitialState = {
    partnerInfo: FinancePartnerInfo;
    agreements: TPlatformUseGetData[];
    agreementDetails: TPlatformAgreementDetails;
    selectedAgreement: TPlatformUseGetData | null;
    createCashAgreement: boolean;
    agreementsTabs: TPlatformUseGetData[];
    isEditCashAgre: boolean;
    isOpened: boolean;
    agreementLabelBool: 'partner' | 'agreement'
};

const initialState: TinitialState = {
    partnerInfo: {
        finPartnerId: 0,
        finPartnerName: "",
        agreements: []
    },
    isOpened: false,
    agreements: [],
    agreementDetails: {
        id: 0,
        traderId: 0,
        traderName: "",
        traderMobile: "",
        traderEmail: "",
        companyName: "",
        companyMobile: "",
        companyEmail: "",
        status: "",
        cuatomerSignedOn: "",
        companySignedOn: "",
        executedOn: "",
        type: "",
        isNew: false,
        tradeName: "",
        signerName: "",
        traderAddress: {
            city: "",
            country: '',
            locality: "",
            pincode: "",
            state: "",
            street_address: ""
        }
    },
    selectedAgreement: null,
    createCashAgreement: false,
    agreementsTabs: [],
    isEditCashAgre: false,
    agreementLabelBool: "partner"
};
const finPartnerAgreementSlice = createSlice({
    name: "finPartnerAgreementSlice",
    initialState: initialState,
    reducers: {
        setAgreements: (state, action: PayloadAction<TPlatformUseGetData[]>) => {
            state.agreements = action.payload
        },
        setAddFinPartnerAgreement: (
            state,
            action: PayloadAction<{
                borrowerId: number;
            }>
        ) => {
            state.agreementDetails = {
                traderId: action.payload.borrowerId,
                id: 0,
                traderName: "",
                traderMobile: "",
                traderEmail: "",
                companyName: "Rama Rao Kancharapu",
                companyMobile: "8337922222",
                companyEmail: "rama@onoark.com",
                status: "",
                cuatomerSignedOn: "",
                companySignedOn: "",
                executedOn: "",
                type: "",
                isNew: false,
                tradeName: "",
                traderAddress: {
                    city: "",
                    country: "INDIA",
                    locality: "",
                    pincode: "",
                    state: "",
                    street_address: "",
                },
                signerName: "",
            };
        },
        updateAgreementDetails: (
            state,
            action: PayloadAction<{
                agreementDetails: TPlatformAgreementDetails;
            }>
        ) => {
            state.agreementDetails = action.payload.agreementDetails;
        },
        setSelectedAgreement: (
            state,
            action: PayloadAction<TPlatformUseGetData>
        ) => {
            state.selectedAgreement = action.payload;
        },
        setCreateFinAgreement: (state, action: PayloadAction<boolean>) => {
            state.createCashAgreement = action.payload
        },
        setAgreementTabs: (state, action: PayloadAction<TPlatformUseGetData[]>) => {
            state.agreementsTabs = action.payload
        },
        setIsEditAgreement: (state, action: PayloadAction<boolean>) => {
            state.isEditCashAgre = action.payload;
        },
        setInitiateFinPartnerAgreement: (state, action: PayloadAction<{
            partnerInfo: FinancePartnerInfo,
        }>) => {
            let agreementsTabs = [...state.agreementsTabs];
            const newTab: TPlatformUseGetData = {
                agmtData: [],
                agmtDocs: [],
                date: "",
                docketId: "",
                isNew: true,
                orderId: "",
                id: agreementsTabs ? agreementsTabs?.length + 1 : 0,
            };
            state.agreementsTabs = [...state.agreementsTabs, newTab];
            state.createCashAgreement = true;
            state.selectedAgreement = newTab;
            state.partnerInfo = action.payload.partnerInfo;
            state.agreementDetails = {
                ...initialState.agreementDetails,
            };
        },
        updateFinPartnerOpened: (state, action: PayloadAction<{
            value: boolean;
            partnerInfo: FinancePartnerInfo;
        }>) => {
            state.isOpened = action.payload.value;
            state.partnerInfo = action.payload.partnerInfo;
        },
        updateEditAgreementDetails: (state, action: PayloadAction<{
            details: TUseAgreementData;
        }>) => {
            let details = action.payload.details;
            state.agreementDetails = {
                traderId: details.traderId,
                id: details.agmtId,
                traderName: details.tradeName,
                traderMobile: details.signerMobile,
                traderEmail: details.signerEmail,
                companyName: "Rama Rao Kancharapu",
                companyMobile: "8337922222",
                companyEmail: "rama@onoark.com",
                status: "",
                cuatomerSignedOn: "",
                companySignedOn: "",
                executedOn: "",
                type: "",
                isNew: false,
                tradeName: details.tradeName,
                traderAddress: {
                    city: details.city,
                    country: "INDIA",
                    locality: details.locality,
                    pincode: details.pincode,
                    state: details.state,
                    street_address: details.streetAddress,
                },
                signerName: details.signerName,
            };
        },
        setAgreementLabelBool: (state, action: PayloadAction<'partner' | 'agreement'>) => {
            state.agreementLabelBool = action.payload
        }
    },
});

export const {
    setAgreements,
    setAddFinPartnerAgreement,
    setSelectedAgreement,
    setCreateFinAgreement,
    setAgreementTabs,
    setIsEditAgreement,
    updateAgreementDetails,
    setInitiateFinPartnerAgreement,
    updateFinPartnerOpened,
    updateEditAgreementDetails,
    setAgreementLabelBool
} = finPartnerAgreementSlice.actions;
export default finPartnerAgreementSlice.reducer;
